import { JsonLd } from 'react-schemaorg';
import { Restaurant } from 'schema-dts';
import { consumer } from '@tock/coretypes';
import { getSameAs } from 'utils/getSameAs';

interface BusinessHomepageJsonLdProps {
  business: consumer.BusinessConfig;
}

export const BusinessHomepageJsonLd: React.FC<BusinessHomepageJsonLdProps> = ({ business }) => {
  return (
    <JsonLd<Restaurant>
      item={{
        '@context': 'https://schema.org',
        '@type': 'Restaurant',
        '@id': `https://www.exploretock.com/${business.domainName}`,
        name: business.name,
        url: `https://www.exploretock.com/${business.domainName}/?utm_source=search`,
        sameAs: getSameAs(business) ?? [],
        email: business.email,
        telephone: business.customerFacingPhone,
        logo: business.emailLogoUrl,
        image: business.heroImageUrl,
        description: business.description,
        priceRange: business.priceRange,
        servesCuisine: business.cuisines,
        location: {
          '@type': 'Place',
          geo: {
            '@type': 'GeoCoordinates',
            address: {
              '@type': 'PostalAddress',
              streetAddress: business.address,
              addressLocality: business.city,
              addressRegion: business.state,
              postalCode: business.zipCode,
              addressCountry: business.country,
            },
          },
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: business.address,
          addressLocality: business.city,
          addressRegion: business.state,
          postalCode: business.zipCode,
          addressCountry: business.country,
        },
        potentialAction: [
          {
            '@type': 'ReserveAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: "${data.baseUrl + '/?utm_source=search'}",
              actionPlatform: [
                'http://schema.org/MobileWebPlatform',
                'http://schema.org/DesktopWebPlatform',
                'http://schema.org/IOSPlatform',
                'http://schema.org/AndroidPlatform',
              ],
            },
            result: {
              '@type': 'FoodEstablishmentReservation',
              name: `Reserve a table at ${business.name
                .replace(/^"(.*)"$/, '$1')
                .replace(/"/g, '"')}`,
              provider: {
                '@type': 'Person',
                name: 'Tock',
              },
            },
          },
        ],
      }}
    />
  );
};
